import { render, staticRenderFns } from "./LogisticsCompliance.vue?vue&type=template&id=4d1d488d&scoped=true&"
var script = {}
import style0 from "./LogisticsCompliance.vue?vue&type=style&index=0&id=4d1d488d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1d488d",
  null
  
)

export default component.exports